import {Observable} from 'rxjs';
import {SCREEN_SIZE} from '../../classes/enums';

export abstract class ResizeService {
  abstract onResize(): Observable<Event>;
  abstract getMediaQuerySize(): SCREEN_SIZE;
}
